/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForGcpSaasUserManagedIndividual extends models.StorageConfigurationBaseForGcpSaas {
    constructor() {
        super();
        this.setDiscriminator("StorageConfigurationForGcpSaasUserManagedIndividual");
    }

    getFixupPrototypeFunction() { return StorageConfigurationForGcpSaasUserManagedIndividual.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForGcpSaasUserManagedIndividual>): StorageConfigurationForGcpSaasUserManagedIndividual {
        let obj = Object.assign(new StorageConfigurationForGcpSaasUserManagedIndividual(), model);
        StorageConfigurationForGcpSaasUserManagedIndividual.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForGcpSaasUserManagedIndividual>): StorageConfigurationForGcpSaasUserManagedIndividual {
        if (!model) return null;
        return StorageConfigurationForGcpSaasUserManagedIndividual.newInstance(<StorageConfigurationForGcpSaasUserManagedIndividual> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForGcpSaasUserManagedIndividual) {
        if (!obj) return;

        models.StorageConfigurationForGcpSaasUserManagedIndividual.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForGcpSaasUserManagedIndividual): boolean {
        if (models.StorageConfigurationBaseForGcpSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForGcpSaasUserManagedIndividual.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
